import React from 'react';
import { Form } from 'react-bootstrap';


class StateSelector extends React.Component {
  render() {
    var state = this.props.state;
    var country = this.props.country;
    var countries = this.props.countries;
    var onChange = this.props.onChange;

    var states = [];
    if (countries && country) {
      for (var i = 0; i < countries.length; i++) {
        var countryOption = countries[i];

        if (countryOption.key == country) {
          if (countryOption.states && countryOption.states.length) {
            states.push(<option key="empty" value="">Select an option...</option>);

            for (var j = 0; j < countryOption.states.length; j++) {
              var stateOption = countryOption.states[j];

              states.push(<option key={stateOption.key} value={stateOption.key}>{stateOption.name}</option>);
            }
          }
        }
      }
    }


    // if there are no states, then clear them out.
    if (states.length) {
      return (
        <Form.Group>
          <Form.Label htmlFor={this.props.id}>
            State / County
          </Form.Label>
          <Form.Control
            as="select"
            name={this.props.name}
            id={this.props.id}
            custom
            value={state}
            onChange={onChange}
            required
            autoComplete="address-level1"
          >
            {states}
          </Form.Control>
        </Form.Group>
      );
    } else {
      return (<input type="hidden" name={this.props.name} value="" />);
    }
  }
}


export default StateSelector;

